import { useRef } from 'react'
import { QRPreview, type QRPreviewRef } from './QRPreview'
import { QRControls } from './QRControls'
import { QRDownload } from './QRDownload'
import { QRPresets } from './QRPresets'
import type { QRSettings } from '../../types/qr'
import './QRGenerator.scss'

interface QRGeneratorProps {
  settings: QRSettings
  onSettingsChange: (settings: QRSettings) => void
}

export function QRGenerator({ settings, onSettingsChange }: QRGeneratorProps) {
  const qrRef = useRef<QRPreviewRef>(null)

  const handlePresetSelect = (presetSettings: Partial<QRSettings>) => {
    onSettingsChange({ ...settings, ...presetSettings })
  }

  return (
    <div className="qr-generator">
      <div className="qr-generator-controls">
        <QRControls settings={settings} onSettingsChange={onSettingsChange} />
      </div>
      <div className="qr-generator-preview">
        <QRPreview ref={qrRef} settings={settings} />
        <QRDownload qrRef={qrRef} settings={settings} />
        <div className="preview-divider" />
        <QRPresets onSelectPreset={handlePresetSelect} currentSettings={settings} />
      </div>
    </div>
  )
}
